import { FormGroup } from '@angular/forms';
import { ApplianceDetailsModelSerialForm } from './appliance-details-model-serial-form.interface';

export type ApplianceDetailsModelSerialFormValue = ReturnType<
  FormGroup<ApplianceDetailsModelSerialForm>['getRawValue']
>;
